import { Theme, css, useTheme } from '@emotion/react';

import { Trans, useTranslation } from 'next-i18next';

import { Radius, Sizes, Spacing, Typography } from 'chatie-design-system';
import { Icon, InfoCircle } from 'chatie-design-system/icon';

import { textColor } from '@styles/css';

import DottedList from '../common/DottedList';
import Modal, { ModalButton, ModalProps } from '../common/Modal';

const mainTextCSS = (theme: Theme) => textColor(theme.colors.main500);
const headerTextCSS = () => css`
  padding-top: 14px;
`;

const dotContainerCSS = () => (theme: Theme) =>
  css`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    background-color: ${theme.var.gray100};
    padding: ${Spacing.medium}px 0;
    border-radius: ${Radius.medium}px;
  `;

const infoTextCSS = () => (theme: Theme) =>
  css`
    display: flex;
    gap: 4px;
    align-items: center;
    margin-top: 12px;
    margin-bottom: -12px;
    color: ${theme.var.gray500};
    ${Typography.body12}
  `;

const HonorApplicantModal = (props: ModalProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const items = [
    <p className="multiline">
      <Trans t={t} i18nKey="명예작품 기다리면 무료 모달 설명1">
        매월 1일 신규 <b css={mainTextCSS}>명예작품</b>이 선정됩니다.
      </Trans>
    </p>,
    <p className="multiline">
      <Trans t={t} i18nKey="명예작품 기다리면 무료 모달 설명2">
        명예작품으로 선정되는 모든 작품은{'\n'}
        <b css={mainTextCSS}>기다리면 무료</b>로 전환됩니다.
      </Trans>
    </p>,
    <p className="multiline">
      <Trans t={t} i18nKey="명예작품 기다리면 무료 모달 설명3">
        기존 예약 회차는 모두 ‘전부 공개’로 전환됩니다.
      </Trans>
    </p>,
    <p className="multiline">
      <Trans t={t} i18nKey="명예작품 기다리면 무료 모달 설명4">
        <b css={mainTextCSS}>기다리면 무료</b>가 적용된 작품의 첫 3회차는 무료,
        {'\n'}최신화 3회차는 유료로 제공됩니다.
      </Trans>
    </p>,
  ];

  return (
    <Modal
      {...props}
      title={
        <p className="multiline" css={headerTextCSS}>
          {t('명예작품\n[기다리면 무료] 전환 안내')}
        </p>
      }
      hideHeaderBorder
      hideCloseButton
    >
      <DottedList items={items} css={dotContainerCSS} />
      <div css={infoTextCSS}>
        <Icon icon={InfoCircle} size={Sizes.medium} color={theme.var.gray500} />
        <p className="multiline">
          {t(
            '명예작품의 ‘기다리면 무료’ 전환은 작가의 결정이 아닌\n채티의 내부 정책임을 안내드립니다.'
          )}
        </p>
      </div>
      <ModalButton text={t('확인')} />
    </Modal>
  );
};

export default HonorApplicantModal;
